export enum BuildStatusEnum {
  SUCCEEDED = 'Succeeded',
  PENDING = 'InProgress',
  STOPPING = 'Stopping',
  STOPPED = 'Stopped',
  CANCELLED = 'Cancelled',
  FAILED = 'Failed',
}
